import { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, makeStyles, ButtonBase, TableHead, TableRow, TableCell, TableBody, Table } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import {
  AddIcon,
  ArrowLeftIcon,
  CloseIcon,
  DeleteIcon,
  DropDownIcon,
  DropUpIcon,
  EqualIcon,
  FilterIcon,
  OccupiedIcon,
} from '../../../../components/Icon';
import Text from '../../../../components/Text';
import StyleButton from '../../../../components/StyleButton';
import LongRemark from '../../../../components/LongRemark';
import Remark from '../../../../components/Remark';
import Dialog from '../../../../components/Dialog';
import WardAssignmentFilter from '../../components/Popups/WardAssignmentFilter';
import { eadmissionAPI } from '../../../../apis';
import CallingCalledUI from '../../components/BusStop/components/CallingCalledUI';
import { conditional, initValue } from '../../../../utils';
import admissionUtil from '../../../../utils/admissionUtil';
import { Alert } from '../../../../components';
import { i18n } from '../../../../language';
import CubicleView from '../../../../components/CubicleView';
import { useQuery } from '../../../../utils/useQuery';
import { useActionableTicketReminder } from '../../../../utils/hooks';
import CancelAssignedPopup from '../../components/Popups/CancelAssignedPopup';
import { useAdmissionVersionError } from '../EAdmissionForm';
import { updateBedStatusViewVal } from '../../../../redux/actions';
import { CUBICLE_VIEW2 } from '../../../../redux/constant';

const useStyles = makeStyles((theme) => ({
  backBtn: {
    gap: '0.5rem',
    color: '#538FFF',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
  },
  arrowLeftIcon: {
    color: '#538FFF',
    fontSize: '1rem',
  },
  border: {
    height: '1px',
    backgroundColor: '#E4E7EB',
  },
  table: {
    '& .MuiTableCell-root': {
      border: 'none',
      padding: '1.25rem 1rem 1.25rem 0',
      fontSize: '1rem',
      color: '#2E4469',
    },
    '& .MuiTableHead-root': {
      '& .MuiTableRow-root': {
        backgroundColor: '#fff',
      },
      '& .MuiTableCell-root': {
        color: '#538fff',
        padding: '0 1rem 0.75rem 0',
        backgroundColor: '#fff',
        fontSize: '0.75rem',
        fontFamily: 'NotoSans-Bold',
        textTransform: 'uppercase',
      },
    },
    '& .MuiTableBody-root': {
      '& .MuiTableCell-root': {
        borderBottom: '1px solid #E4E7EB',
      },
      '&>tr:last-child': {
        '& .MuiTableCell-root': {
          borderBottom: 'none',
        },
      },
    },
  },
  pendingTable: {
    '& .MuiTableCell-root': {
      border: 'none',
      padding: '1.25rem 1rem 1.25rem 0',
      fontSize: '1rem',
      color: '#2E4469',
    },
    '& .MuiTableHead-root': {
      '& .MuiTableRow-root': {
        backgroundColor: '#fff',
      },
      '& .MuiTableCell-root': {
        color: '#538fff',
        padding: '1.25rem 1rem 0.75rem 0',
        backgroundColor: '#fff',
        fontSize: '0.75rem',
        fontFamily: 'NotoSans-Bold',
        textTransform: 'uppercase',
      },
    },
    '& .MuiTableBody-root': {
      '& .MuiTableCell-root': {
        borderBottom: '1px solid #E4E7EB',
      },
      '&>tr:last-child': {
        '& .MuiTableCell-root': {
          borderBottom: 'none',
        },
      },
    },
  },
  OccupiedIcon: {
    fontSize: '1.2rem',
    color: '#FFF',
  },
  RefreshIcon: {
    fontSize: '1.4375rem',
    color: '#538FFF',
  },
  addBtn: {
    width: '2.25rem',
    height: '2.25rem',
    backgroundColor: '#538FFF',
    borderRadius: '8px',
  },
  addIcon: {
    fontSize: '1.125rem',
    color: '#FFF',
  },
  OveraAddBtn: {
    width: '2.25rem',
    height: '2.25rem',
    backgroundColor: '#ff655c',
    borderRadius: '8px',
  },
  locationBtn: {
    color: '#538FFF',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
    textDecorationLine: 'underline',
  },
  pageBtn: {
    width: '2.875rem',
    height: '2.875rem',
    borderRadius: '5px',
    border: '1px solid #E4E7EB',
    '&:disabled': {
      opacity: '0.5',
    },
  },
  dropIcon: {
    color: '#538FFF',
    fontSize: '0.8rem',
  },
  EqualIcon: {
    color: '#538FFF',
    fontSize: '1.125rem',
    marginTop: '0.25rem',
  },
  filterBox: {
    display: 'flex',
    background: '#538fff',
    marginRight: '0.938rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '0.5rem',
  },
  filterAll: {
    width: '6.25rem',
    height: '2.938rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#fff',
  },
  filterIconAll: {
    width: '1.438rem',
    height: '1.438rem',
    color: '#fff',
    marginRight: '0.625rem',
  },
  closeIcon: {
    width: '1rem',
    height: '1rem',
    color: '#fff',
    marginRight: '0.6rem',
  },
  filterIcon: {
    width: '1.438rem',
    height: '1.438rem',
    color: '#538fff',
    marginRight: '0.625rem',
  },
  // isOver: {
  //   background: '#ff655c',
  //   color: 'white',
  //   borderRadius: '0.3rem',
  //   alignItems: 'center',
  // },
}));

const pageSize = 10;

const statusEnum = {
  P: 'Pending',
  A: 'Acknowledged',
  R: 'Redirected',
  W: 'Case withdrawn',
};

const handleHideAddIcon = (list, currentId) => {
  return _.some(list, (item) => item.specialtyWardlocId === currentId);
};

const WardAssignment = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { id, eaId, gender, specialtyCode, subSpecialtyCode, actionableMode, isolationRoomCode, isMatchedAge } =
    useQuery();
  const defaultGender = conditional(
    gender !== 'null',
    conditional(gender.toUpperCase() === 'X', ['X'], [gender, 'X']),
    ['X']
  );
  const defaultIsolationRoom = conditional(
    isolationRoomCode === 'null',
    ['Undefined', 'Non-Iso'],
    ['Undefined', 'Any-Iso', isolationRoomCode]
  );
  const [reminder, setReminder] = useState(false);
  const [filterPopup, setFilterPopup] = useState(false);
  const [filterInfo, setFilterInfo] = useState({
    pageNo: 1,
    eaId: Number(eaId),
    filter: {
      cubicleGender: [],
      cubicleType: [],
      gender: [...defaultGender],
      isExcludingAddedbed: false,
      isLessthanThreshold: false,
      remark: [],
      status: [],
      specialtyCode: specialtyCode === 'null' ? null : specialtyCode,
      subSpecialtyCode: subSpecialtyCode === 'null' ? null : subSpecialtyCode,
      isoRooms: [...defaultIsolationRoom],
      isMatchedAge: Number(isMatchedAge),
    },
  });
  useActionableTicketReminder('audio', 'AD');
  // reset数据
  const [initFilterInfo, setInitFilterInfo] = useState({
    filter: {
      cubicleGender: [],
      cubicleType: [],
      gender: [],
      isExcludingAddedbed: false,
      isLessthanThreshold: false,
      remark: [],
      status: [],
      specialtyCode: null,
      subSpecialtyCode: null,
      isoRooms: [],
      isMatchedAge: 0,
    },
  });
  // 点击close传的数据
  const [init, setInit] = useState({
    pageNo: 1,
    eaId: Number(eaId),
    filter: {
      cubicleGender: [],
      cubicleType: [],
      gender: [],
      isExcludingAddedbed: false,
      isLessthanThreshold: false,
      remark: [],
      status: [],
      specialtyCode: null,
      subSpecialtyCode: null,
      isoRooms: [],
      isMatchedAge: 0,
    },
  });

  const CloseFilter = () => {
    setFilterInfo(init);
  };
  const [data, setData] = useState({
    wardPendingAssignment: [],
    assignmentList: [],
    callingCalled: [],
    total: 0,
    version: 0,
  });
  const [maxPage, setMaxPage] = useState(1);
  const [btnCtrl, setBtnCtrl] = useState();
  const [maxSeq, setMaxSeq] = useState(0);
  const [firstGetData, setFirstGetData] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [wardLocation, setWardLocation] = useState({ open: false, wardLocation: '', hospCode: '', wardId: '' });
  const [getSpecialFlag, setGetSpecialFlag] = useState(false);
  const [cancelAssignWardPopup, setCancelAssignWardPopup] = useState(false);

  const setDefaultSpecial = () => {
    setFilterInfo((preData) => ({
      ...preData,
      filter: {
        ...preData.filter,
        specialtyCode: null,
        subSpecialtyCode: null,
      },
    }));
    setInitFilterInfo((preData) => ({
      ...preData,
      filter: {
        ...preData.filter,
        specialtyCode: null,
        subSpecialtyCode: null,
      },
    }));
    setInit((preData) => ({
      ...preData,
      filter: {
        ...preData.filter,
        specialtyCode: null,
        subSpecialtyCode: null,
      },
    }));
  };

  const getHospSpecList = async () => {
    try {
      const { result } = await eadmissionAPI.getHospSpec();
      console.log('res', result);
      if (
        _.some(
          result,
          (item) => specialtyCode === String(item.specialtyCode) && subSpecialtyCode === String(item.subSpecialtyCode)
        )
      ) {
        setGetSpecialFlag(true);
      } else {
        setDefaultSpecial();
        setGetSpecialFlag(true);
      }
    } catch (err) {
      setDefaultSpecial();
      setGetSpecialFlag(true);
    }
  };

  useEffect(() => {
    getHospSpecList();
  }, []);

  const handleConfirm = (form) => {
    setFilterPopup(false);
    const wardLocStatusValues =
      form.wardLocStatus.length === 0 ? form.wardLocStatus : form.wardLocStatus.map((item) => item.value);
    const wardLocRemarkValues =
      form.wardLocRemark.length === 0 ? form.wardLocRemark : form.wardLocRemark.map((item) => item.value);
    const cubicleTypeArr =
      form.cubicleTypeArr.length === 0 ? form.cubicleTypeArr : form.cubicleTypeArr.map((item) => item.value);

    setFilterInfo((o) => ({
      ...o,
      pageNo: 1,
      filter: {
        ...o.filter,
        cubicleGender: form.cubicle,
        cubicleType: cubicleTypeArr[0] === '' ? [] : cubicleTypeArr,
        gender: form.gender,
        isExcludingAddedbed: form.excludingAddedBed,
        isLessthanThreshold: form.show,
        remark: wardLocRemarkValues[0] === '' ? [] : wardLocRemarkValues,
        status: wardLocStatusValues[0] === '' ? [] : wardLocStatusValues,
        specialtyCode: form.specialty === 'null' ? null : form.specialty,
        subSpecialtyCode: form.subSpecialtyCode === 'null' ? null : form.subSpecialtyCode,
        isoRooms: form.isoRooms,
        isMatchedAge: form?.isMatchedAge ? 1 : 0,
      },
    }));
    console.log('form', form);
  };
  const getAssignWardPendingAssList = useCallback(async () => {
    try {
      if (filterInfo.pageNo === 0 || !getSpecialFlag) {
        return;
      }
      const params = {
        ...filterInfo,
        pageSize,
      };
      const { result } = await eadmissionAPI.getAssignWardPendingAssList(params);
      setMaxPage(Math.ceil(result.count / pageSize));
      setData((preData) => ({
        ...preData,
        wardPendingAssignment: result.assignWards,
        assignmentList: firstGetData ? preData.assignmentList : result.pendingWards,
        total: result.count,
        version: result.version,
      }));

      setMaxSeq((preSeq) => {
        let tempSeq = preSeq;
        _.forEach(result.assignmentList, (item) => {
          if (item.pendingAssignSeq > tempSeq) {
            tempSeq = item.pendingAssignSeq;
          }
        });
        return tempSeq;
      });
      setFirstGetData(true);
      if (result.count === 0) {
        setFilterInfo((preInfo) => ({
          ...preInfo,
          pageNo: 0,
        }));
      }
    } catch (error) {}
  }, [filterInfo, getSpecialFlag]);

  const getCallingCalled = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getCallingCalled({ txnBusStopId: id });
      setData((preData) => ({
        ...preData,
        callingCalled: result.callingCalled,
      }));
    } catch (error) {}
  }, [id]);

  useEffect(() => {
    getCallingCalled();
  }, [getCallingCalled]);

  useEffect(() => {
    getAssignWardPendingAssList();
  }, [getAssignWardPendingAssList]);

  const showPendingList = useMemo(() => {
    return data.assignmentList.length > 0;
  }, [data.assignmentList]);

  const handlePage = (type) => () => {
    setFilterInfo((preData) => ({
      ...preData,
      pageNo: type === 'next' ? preData.pageNo + 1 : preData.pageNo - 1,
    }));
  };

  const handleAddToPendingList = (rowData) => () => {
    setData((preData) => ({
      ...preData,
      assignmentList: [...preData.assignmentList, { ...rowData, pendingAssignSeq: maxSeq + 1 }],
    }));
    setMaxSeq((preSeq) => preSeq + 1);
  };

  const handleDeletePendingList = (id) => () => {
    setData((preData) => ({
      ...preData,
      assignmentList: _.filter(preData.assignmentList, (item) => item.specialtyWardlocId !== id),
    }));
  };

  const getBtnDisplay = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getAssignDisplay({ eaId });
      setBtnCtrl(result);
    } catch (error) {}
  }, [eaId]);

  useEffect(() => {
    getBtnDisplay();
  }, [getBtnDisplay]);

  const handleAdmissionVersionError = useAdmissionVersionError();
  const assignAdmission = useCallback(
    async (actionType, save) => {
      try {
        if (actionType !== 7 && data.assignmentList.length === 0) {
          setReminder(true);
          return;
        }
        const params = {
          actionType,
          eaId: Number(eaId),
          unitType: btnCtrl?.UNIT_TYPE,
          pendingInfos: _.map(data.assignmentList, (item) => ({
            pendingAssignSeq: item.pendingAssignSeq,
            specialtyWardlocId: item.specialtyWardlocId,
          })),
          version: data.version,
        };
        await eadmissionAPI.editAdmission(params);
        if (save) {
          getBtnDisplay();
          getAssignWardPendingAssList();
          getCallingCalled();
          setSuccessAlert(true);
          setTimeout(() => {
            history.goBack();
          }, 1000);
        } else {
          history.goBack();
        }
      } catch (error) {
        handleAdmissionVersionError(error);
      }
    },
    [btnCtrl, eaId, data.assignmentList, getBtnDisplay, getAssignWardPendingAssList, getCallingCalled]
  );

  const handleBtnEvents = (type) => () => {
    switch (type) {
      case 'Save':
        assignAdmission(11, true);
        break;
      case 'Assign':
        assignAdmission(6, true);
        break;
      case 'Cancel':
        history.goBack();
        break;
      case 'Re-assign to next ward':
        assignAdmission(12, false);
        break;
      case 'Cancel Assigned Ward':
        setCancelAssignWardPopup(true);
        break;

      default:
        assignAdmission(12, false);
        break;
    }
  };

  const handleOpenWardLocation = (wardLocation, hospCode, wardId) => () => {
    dispatch(updateBedStatusViewVal({ currentViewType: CUBICLE_VIEW2, isCubicleV2: true }));
    setWardLocation({
      open: true,
      wardLocation,
      hospCode,
      wardId,
    });
  };

  return (
    <Box>
      <Dialog
        open={reminder}
        title="Reminder"
        confirm="Back"
        handleClose={() => setReminder(false)}
        handleConfirm={() => setReminder(false)}
        dialogfootStyle={{ boxShadow: '0px -1px 0px 0px #E4E7EB', paddingTop: '1rem', marginTop: '2.5rem' }}
        dialogRootStyle={{ paddingBottom: '1rem' }}
      >
        <Text color="#2E4469" fontSize="1rem">
          There should be at least one ward location in the pending assignment list.
        </Text>
      </Dialog>
      {filterPopup && (
        <WardAssignmentFilter
          close={filterPopup}
          handleClose={() => setFilterPopup(false)}
          handleConfirm={handleConfirm}
          defGender={defaultGender}
          defSpec={specialtyCode}
          filterInfo={filterInfo}
          defSubSpec={subSpecialtyCode}
          defaultIsolationRoom={defaultIsolationRoom}
        />
      )}
      {wardLocation.open && (
        <CubicleView
          {...wardLocation}
          onClose={() => setWardLocation({ open: false, wardLocation: '', hospCode: '', wardId: '' })}
        />
      )}
      {/* header */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p="0 2.63rem"
        height="4.375rem"
        bgcolor="#FFF"
        boxShadow="0px 1px 0px 0px #E4E7EB"
      >
        <ButtonBase className={classes.backBtn} onClick={() => history.goBack()}>
          <ArrowLeftIcon className={classes.arrowLeftIcon} /> Back
        </ButtonBase>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          // boxShadow="0px -1px 1px 0px #E4E7EB"
          // p="1.25rem"
          borderRadius="0 0 15px 15px"
          gridGap="1.25rem"
        >
          {btnCtrl?.BTNS?.map((item) => (
            <StyleButton
              key={item}
              onClick={handleBtnEvents(item)}
              height="2.875rem"
              {...admissionUtil.getAssignmentBtn(item)}
            />
          ))}
        </Box>
        <div />
      </Box>

      {/* Body */}
      <Box p="1.88rem 3.44rem 0">
        <Text color="#2E4469" fontSize="1.5rem" fontFamily="NotoSans-Bold">
          Ward Assignment
        </Text>
        <Box
          display="flex"
          flexDirection="column"
          height={`calc(100vh - ${actionableMode === '1' ? 10 : 15}rem)`}
          overflow="hidden auto"
          mt="1.25rem"
        >
          <Box
            display="flex"
            flexDirection="column"
            p="1.44rem 1.81rem 0 1.94rem"
            bgcolor="#FFF"
            borderRadius="15px 15px 0 0"
          >
            <Box display="flex" alignItems="center">
              <Text color="#2E4469" fontSize="1.25rem">
                Calling & Called
              </Text>
              <LongRemark content="" />
            </Box>
            <Box display="flex" justifyContent="space-between" mt="2.3rem">
              {data.callingCalled.length > 0 && <CallingCalledUI data={data.callingCalled} />}
              {/* <Box>
              <StyleButton
                Icon={CircleCloseIcon2}
                text="Cancel Calling"
                type="fill"
                backgroundColor="#FF655C"
                width="10.375rem"
                iconStyle={{ fontSize: '1.375rem', color: '#FFF' }}
              />
              <Text>Cancel calling to VHC23</Text>
            </Box> */}
            </Box>
            <div className={classes.border} />
            <Box display="flex" justifyContent="space-between" mt="1.87rem">
              <Text color="#2E4469" fontSize="1.25rem">
                Assign wards to the pending assignment list
              </Text>
              <Box display="flex">
                {JSON.stringify(filterInfo.filter) === JSON.stringify(initFilterInfo.filter) ? (
                  <StyleButton
                    Icon={FilterIcon}
                    text="Filter"
                    onClick={() => {
                      setFilterPopup(true);
                    }}
                    backgroundColor="#FFF"
                    border="1px solid #E4E7EB"
                  />
                ) : (
                  <div className={classes.filterBox}>
                    <ButtonBase
                      className={classes.filterAll}
                      onClick={() => {
                        setFilterPopup(true);
                      }}
                    >
                      <FilterIcon className={classes.filterIconAll} />
                      Filter
                    </ButtonBase>
                    <ButtonBase>
                      <CloseIcon className={classes.closeIcon} onClick={CloseFilter} />
                    </ButtonBase>
                  </div>
                )}
              </Box>
            </Box>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Hosp</TableCell>
                  <TableCell>Ward place unit</TableCell>
                  <TableCell>Ward Location</TableCell>
                  <TableCell>Isolation Room</TableCell>
                  <TableCell>Gender</TableCell>
                  <TableCell>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      width="1.875rem"
                      height="1.875rem"
                      borderRadius="5px"
                      bgcolor="#FF655C"
                      pl="0.2rem"
                    >
                      <OccupiedIcon className={classes.OccupiedIcon} />
                    </Box>
                  </TableCell>
                  {/* <TableCell>Threshold</TableCell> */}
                  <TableCell>Last ward assignment</TableCell>
                  <TableCell>ward Location Status</TableCell>
                  <TableCell>ward Location Remark</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {data.wardPendingAssignment.map((item) => (
                  <TableRow key={item.specialtyWardlocId}>
                    <TableCell>{item.hospCode}</TableCell>
                    <TableCell>{item.wardName}</TableCell>
                    <TableCell>
                      <ButtonBase
                        className={classes.locationBtn}
                        onClick={handleOpenWardLocation(item.wardLocation, item.hospCode, item.unitId)}
                      >
                        {item.wardLocation}
                      </ButtonBase>
                    </TableCell>
                    <TableCell>{`${initValue(item.isoRoom, '-')}`}</TableCell>
                    <TableCell>{item.gender}</TableCell>
                    <TableCell>
                      <Box display="flex">
                        {item.rateInfo.free === 0 ? (
                          '--'
                        ) : (
                          <Box style={{ whiteSpace: 'pre-wrap' }}>
                            <Box display="flex">
                              <Box
                                // className={
                                //   parseInt(item.rateInfo.rate) >= parseInt(item.occThreshold) ? classes.isOver : ''
                                // }
                                p="0.5rem"
                              >
                                {`${item.rateInfo.used}/${item.rateInfo.free}    ${item.rateInfo.rate}`}
                              </Box>
                            </Box>
                            {item?.rateInfo?.wardCds?.length > 1 && (
                              <Box ml="1.13rem">
                                {item?.rateInfo?.wardCds.map((wardRateItem) => (
                                  <Box color="#538FFF" key={wardRateItem.wardCd}>
                                    {`${wardRateItem.wardCd}: ${wardRateItem.used}/${wardRateItem.free} ${
                                      wardRateItem.rate ?? '--'
                                    }`}
                                  </Box>
                                ))}
                              </Box>
                            )}
                          </Box>
                        )}
                      </Box>
                    </TableCell>
                    {/* <TableCell>{admissionUtil.initThreshold(item.occThreshold)}</TableCell> */}
                    <TableCell>
                      {item.actionDtm && (
                        <Box display="flex" gridGap="0.75rem" alignItems="center">
                          <Box>
                            <Text color="#2E4469" fontSize="1rem">
                              {moment(item.actionDtm).format('YYYY-MM-DD HH:mm')}
                            </Text>
                            <Text color="#7D86A9">({statusEnum[item.replyStatus]})</Text>
                          </Box>
                          {/* <RefreshIcon className={classes.RefreshIcon} /> */}
                        </Box>
                      )}
                    </TableCell>
                    <TableCell>{item.locationStatus}</TableCell>
                    <TableCell>{item.remark && <Remark remark={item.remark} colour={item.colour} />}</TableCell>
                    <TableCell>
                      {handleHideAddIcon(data.assignmentList, item.specialtyWardlocId) || item.isExcludeStatus ? (
                        <Box width="2.25rem" height="2.25rem" />
                      ) : (
                        <ButtonBase
                          className={
                            parseInt(item.rate) >= parseInt(item.occThreshold) ? classes.OveraAddBtn : classes.addBtn
                          }
                          onClick={handleAddToPendingList(item)}
                        >
                          <AddIcon className={classes.addIcon} />
                        </ButtonBase>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
          <div className={classes.border} />
          {/* Page */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p="1.25rem 1.88rem"
            bgcolor="#FFF"
            borderRadius={showPendingList ? '0 0 15px 15px' : 'unset'}
          >
            <Text fontSize="0.875rem">{`${data.total} Wards, total in ${maxPage} Pages`}</Text>
            <Box display="flex" alignItems="center">
              <Text color="#2E4469" fontSize="1.25rem">
                {`${filterInfo.pageNo}/${maxPage}`}
              </Text>
              <ButtonBase
                className={classes.pageBtn}
                disabled={filterInfo.pageNo <= 1}
                style={{ marginLeft: '1.25rem', marginRight: '0.88rem' }}
                onClick={handlePage('prev')}
              >
                <DropUpIcon className={classes.dropIcon} />
              </ButtonBase>
              <ButtonBase
                className={classes.pageBtn}
                disabled={filterInfo.pageNo === maxPage}
                onClick={handlePage('next')}
              >
                <DropDownIcon className={classes.dropIcon} />
              </ButtonBase>
            </Box>
          </Box>
          {/* Footer */}
          <Box
            mt={showPendingList ? '1.44rem' : '0'}
            borderRadius={showPendingList ? '15px' : '0 0 15px 15px'}
            bgcolor="#FFF"
          >
            {showPendingList && (
              <Box p="1.87rem 1.87rem 0">
                <Text color="#2E4469" fontSize="1.25rem">
                  Pending Assignment List
                </Text>
                <Table className={classes.pendingTable}>
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell>Seq.</TableCell>
                      <TableCell>Hosp</TableCell>
                      <TableCell>Ward place unit</TableCell>
                      <TableCell>Ward Location</TableCell>
                      <TableCell>Isolation Room</TableCell>
                      <TableCell>Gender</TableCell>
                      <TableCell>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          width="1.875rem"
                          height="1.875rem"
                          borderRadius="5px"
                          bgcolor="#FF655C"
                          pl="0.2rem"
                        >
                          <OccupiedIcon className={classes.OccupiedIcon} />
                        </Box>
                      </TableCell>
                      {/* <TableCell>Threshold</TableCell> */}
                      <TableCell>Last ward assignment</TableCell>
                      <TableCell>ward Location Status</TableCell>
                      <TableCell>ward Location Remark</TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.assignmentList.map((item) => (
                      <TableRow key={item.specialtyWardlocId}>
                        <TableCell>
                          <EqualIcon className={classes.EqualIcon} />
                        </TableCell>
                        <TableCell>{item.pendingAssignSeq}</TableCell>
                        <TableCell>{item.hospCode}</TableCell>
                        <TableCell>{item.wardName}</TableCell>
                        <TableCell>
                          <ButtonBase
                            className={classes.locationBtn}
                            onClick={handleOpenWardLocation(item.wardLocation, item.hospCode, item.unitId)}
                          >
                            {item.wardLocation}
                          </ButtonBase>
                        </TableCell>
                        <TableCell>{`${initValue(item.isoRoom, '-')}`}</TableCell>
                        <TableCell>{item.gender}</TableCell>
                        <TableCell>
                          <Box display="flex">
                            {item.rateInfo.free === 0 ? (
                              '--'
                            ) : (
                              <Box style={{ whiteSpace: 'pre-wrap' }}>
                                <Box display="flex">
                                  <Box
                                    // className={
                                    //   parseInt(item.rateInfo.rate) >= parseInt(item.occThreshold) ? classes.isOver : ''
                                    // }
                                    p="0.5rem"
                                  >
                                    {`${item.rateInfo.used}/${item.rateInfo.free}    ${item.rateInfo.rate}`}
                                  </Box>
                                </Box>
                                {item?.rateInfo?.wardCds?.length > 1 && (
                                  <Box ml="1.13rem">
                                    {item?.rateInfo?.wardCds.map((wardRateItem) => (
                                      <Box color="#538FFF" key={wardRateItem.wardCd}>
                                        {`${wardRateItem.wardCd}:${wardRateItem.used}/${wardRateItem.free}    ${
                                          wardRateItem.rate ?? '--'
                                        }`}
                                      </Box>
                                    ))}
                                  </Box>
                                )}
                              </Box>
                            )}
                          </Box>
                        </TableCell>
                        {/* <TableCell>{admissionUtil.initThreshold(item.occThreshold)}</TableCell> */}
                        <TableCell>
                          {item.actionDtm && (
                            <Box display="flex" gridGap="0.75rem" alignItems="center">
                              <Box>
                                <Text color="#2E4469" fontSize="1rem">
                                  {moment(item.actionDtm).format('YYYY-MM-DD HH:mm')}
                                </Text>
                                <Text color="#7D86A9">({statusEnum[item.replyStatus]})</Text>
                              </Box>
                              {/* <RefreshIcon className={classes.RefreshIcon} /> */}
                            </Box>
                          )}
                        </TableCell>
                        <TableCell>{item.locationStatus}</TableCell>
                        <TableCell>{item.remark && <Remark remark={item.remark} colour={item.colour} />}</TableCell>
                        <TableCell>
                          <ButtonBase
                            className={
                              parseInt(item.rate) >= parseInt(item.occThreshold) ? classes.OveraAddBtn : classes.addBtn
                            }
                            onClick={handleDeletePendingList(item.specialtyWardlocId)}
                          >
                            <DeleteIcon className={classes.addIcon} />
                          </ButtonBase>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              boxShadow="0px -1px 1px 0px #E4E7EB"
              p="1.25rem 1.25rem 2rem"
              borderRadius="0 0 15px 15px"
              gridGap="1.25rem"
            >
              {btnCtrl?.BTNS?.map((item) => (
                <StyleButton
                  key={item}
                  onClick={handleBtnEvents(item)}
                  height="2.875rem"
                  {...admissionUtil.getAssignmentBtn(item)}
                />
              ))}
            </Box>
          </Box>
        </Box>
      </Box>

      {/* alert */}
      <Alert
        open={successAlert}
        id="Alert-aib"
        onClose={() => setSuccessAlert(false)}
        text={i18n.t('DUTYASSIGN_SAVE_SUCCESS_ALERT')}
        type="success"
      />

      {cancelAssignWardPopup && (
        <CancelAssignedPopup
          handleClose={() => setCancelAssignWardPopup(false)}
          handleConfirm={() => {
            assignAdmission(7, false);
          }}
        />
      )}
    </Box>
  );
};

export default WardAssignment;
